import styled from '@emotion/native';
import type { ColorName } from '@emotion/react';
import { Col, Row } from 'components/base';
import type React from 'react';
import { ScrollView } from 'react-native';

import type { SectionProps } from './types';

interface ContentWrapperProps {
  backgroundColor?: ColorName;
}

const ContentWrapper = styled(Row)<ContentWrapperProps>(
  ({ theme, backgroundColor = 'base-grey' }) => ({
    backgroundColor: theme.color[backgroundColor],
  }),
);

interface AsideProps extends SectionProps {
  backgroundColor?: ColorName;
}

export const Aside: React.FC<AsideProps> = ({
  flex = 1,
  hidden = false,
  backgroundColor,
  children,
}) => {
  if (hidden) {
    return null;
  }

  return (
    <ContentWrapper flex={flex} backgroundColor={backgroundColor}>
      <Col flex={1}>
        <ScrollView>{children}</ScrollView>
      </Col>
    </ContentWrapper>
  );
};
